'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var INITIAL_MESSAGE = exports.INITIAL_MESSAGE = 'INITIAL_MESSAGE';